import { createFileRoute, useSearch } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';
import { BrandMark } from '../components/BrandMark';
import { redirectIfLandingOnly } from '../lib/landing-mode';

const verifySearchSchema = z.object({
  email: z.string().email().optional(),
});

export const Route = createFileRoute('/verify')({
  validateSearch: verifySearchSchema,
  beforeLoad: () => {
    redirectIfLandingOnly();
  },
  component: VerifyPage,
});

function VerifyPage() {
  const { t } = useTranslation();
  const { email } = useSearch({ from: '/verify' });

  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center text-center animate-fadeUp">
      <BrandMark />
      <div className="mt-10 max-w-md">
        <h1 className="font-display text-3xl font-light text-ash-100 sm:text-4xl">
          {t('verify.heading')}
        </h1>
        <p className="mt-5 font-body text-ash-300 leading-relaxed sm:text-lg">
          {t('verify.bodyPrefix')}
          {email ? (
            <span className="text-ash-100 italic">{email}</span>
          ) : (
            <span className="italic">{t('verify.bodyInboxFallback')}</span>
          )}
          {t('verify.bodySuffix')}
        </p>
        <p className="mt-3 font-body text-ash-400 text-sm leading-relaxed">
          {t('verify.bodyHint')}
        </p>
      </div>

      <div className="hairline mt-16 h-px w-32" />

      <p className="mt-8 font-body text-ash-500 text-xs">
        {t('verify.spamHintPrefix')}
        <a
          href="/login"
          className="text-ash-300 underline-offset-4 hover:text-moonlit-400 hover:underline"
        >
          {t('verify.spamHintLink')}
        </a>
        {t('verify.spamHintSuffix')}
      </p>
    </div>
  );
}
